import React from 'react';
import './partnerBox.scss';

function PartnerBox (props){
  const { detailOne } = props;
  const len = 5 - detailOne.get('list').size % 5;
  const newArr = new Array(len).fill(1)
  return (
    <div className="part_box">
      <h1 className="part_box_title">{detailOne.get('title')}</h1>
      <div className="part_box_content">
        {
          detailOne.get('list').map(item => {
            return (
              <div className="part_box_content_one" key={item.get('id')}>
                <div className="part_box_content_one_img b_img">
                  <img src={item.get('logo')} alt={item.get('name')}></img>
                </div>
                <p className="part_box_content_one_name">{item.get('name')}</p>
              </div>
            )
          })
        }
        {
          newArr.length>0 && newArr.length!=5 && newArr.map((item,index)=>{
            return (
              <div key={index+item} className="part_box_content_empty"></div>
            )
          })
        }
      </div>
    </div>
  )
}

export default PartnerBox;